/*
  Translations for the Self-hosted page (Enterprise licence).
  Merged into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const SELF_HOSTED_INTRO =
  'Run the tracker on your own server or in a dedicated cloud. Your licence key activates one production server and one test server.';
const SELF_HOSTED_UPSELL =
  'Self-hosted installs come with the Enterprise plan. Servers activated earlier stop once their current licence runs out.';
const SELF_HOSTED_KEY_ONCE =
  'This is the only time the key is shown. Store it somewhere safe: you enter it when you install the tracker.';
const SELF_HOSTED_ROTATE =
  'A new key replaces the current one at once. Servers that still use the old key cannot renew their licence and stop within {days} days unless you enter the new key on them.';
const SELF_HOSTED_DEACTIVATE =
  'The server loses its slot right away and stops within {days} days. Use this when you move the tracker to another server.';
const SELF_HOSTED_RULES =
  'Each server checks in with us once a day and receives a licence valid for {days} days. If it cannot check in, or the subscription ends, it keeps working until that licence runs out and then stops. A test server is limited to {clicks} clicks a day. Only technical data is sent: licence, server id and version, never data about your traffic or your clients.';
const SELF_HOSTED_INSTALL =
  'Run this command as root on a fresh server. In about ten minutes it installs everything (Kubernetes, HTTPS certificates, the database and the tracker). Running it again upgrades the install and keeps the data.';
const SELF_HOSTED_SPEC_SHORT =
  'Your server: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu or Debian (x86-64). The tracker installs with one command.';
const SELF_HOSTED_KEY_HINT =
  'Put your licence key in place of the X: it is shown once, when you issue or rotate it.';
const SELF_HOSTED_EMAIL_HINT =
  'The first account signed up with this email gets administrator rights on the server.';
const SELF_HOSTED_DOMAIN_HINT =
  'Without --domain the tracker starts on an address like 1-2-3-4.sslip.io. For your own domain, first point tracker.example.com and api.tracker.example.com at the server, then add --domain tracker.example.com.';

const ru = {
  [SELF_HOSTED_INTRO]:
    'Запускайте трекер на своём сервере или в выделенном облаке. Лицензионный ключ активирует один рабочий и один тестовый сервер.',
  [SELF_HOSTED_UPSELL]:
    'Установка на свой сервер входит в тариф Enterprise. Ранее активированные серверы остановятся, когда закончится их текущая лицензия.',
  [SELF_HOSTED_KEY_ONCE]:
    'Ключ показывается только один раз. Сохраните его в надёжном месте: он понадобится при установке трекера.',
  [SELF_HOSTED_ROTATE]:
    'Новый ключ сразу заменяет текущий. Серверы со старым ключом не смогут продлить лицензию и остановятся в течение {days} дней, если не ввести на них новый ключ.',
  [SELF_HOSTED_DEACTIVATE]:
    'Сервер сразу теряет свой слот и остановится в течение {days} дней. Используйте это при переносе трекера на другой сервер.',
  [SELF_HOSTED_RULES]:
    'Каждый сервер раз в сутки связывается с нами и получает лицензию на {days} дней. Если связи нет или подписка закончилась, он работает до конца этой лицензии и затем останавливается. Тестовый сервер ограничен {clicks} кликами в сутки. Передаются только технические данные: лицензия, ID сервера и версия — никогда данные о вашем трафике или клиентах.',
  [SELF_HOSTED_INSTALL]:
    'Выполните эту команду от root на чистом сервере. Примерно за десять минут она установит всё: Kubernetes, HTTPS-сертификаты, базу данных и сам трекер. Повторный запуск обновляет установку и сохраняет данные.',
  'Self-hosted': 'Свой сервер',
  'Enterprise': 'Enterprise',
  'Licence key': 'Лицензионный ключ',
  'Issue licence key': 'Выпустить ключ',
  'Rotate key': 'Перевыпустить ключ',
  'Rotate licence key?': 'Перевыпустить ключ?',
  'Licence key issued': 'Ключ выпущен',
  'Server deactivated': 'Сервер отключён',
  'Deactivate this server?': 'Отключить этот сервер?',
  'Servers': 'Серверы',
  'Production': 'Рабочий',
  'Revoked': 'Отозван',
  'Deactivated': 'Отключён',
  'Deactivate': 'Отключить',
  'Issued': 'Выпущен',
  'Version': 'Версия',
  'See plans': 'Посмотреть тарифы',
  'No servers activated yet.': 'Пока ни один сервер не активирован.',
  'Transfers left (30 days)': 'Осталось переносов (30 дней)',
  'Could not load this page.': 'Не удалось загрузить страницу.',
  'Licensing is temporarily unavailable. Try again later.': 'Лицензирование временно недоступно. Попробуйте позже.',
};

const es = {
  [SELF_HOSTED_INTRO]:
    'Ejecuta el tracker en tu propio servidor o en una nube dedicada. Tu clave de licencia activa un servidor de producción y uno de prueba.',
  [SELF_HOSTED_UPSELL]:
    'La instalación en servidor propio está incluida en el plan Enterprise. Los servidores activados antes se detienen cuando vence su licencia actual.',
  [SELF_HOSTED_KEY_ONCE]:
    'Esta es la única vez que se muestra la clave. Guárdala en un lugar seguro: la necesitarás al instalar el tracker.',
  [SELF_HOSTED_ROTATE]:
    'La nueva clave reemplaza a la actual de inmediato. Los servidores que sigan con la clave antigua no podrán renovar su licencia y se detendrán en {days} días si no introduces la nueva clave en ellos.',
  [SELF_HOSTED_DEACTIVATE]:
    'El servidor pierde su plaza de inmediato y se detiene en {days} días. Úsalo cuando muevas el tracker a otro servidor.',
  [SELF_HOSTED_RULES]:
    'Cada servidor se comunica con nosotros una vez al día y recibe una licencia válida por {days} días. Si no puede comunicarse, o la suscripción termina, sigue funcionando hasta que vence esa licencia y luego se detiene. Un servidor de prueba está limitado a {clicks} clics al día. Solo se envían datos técnicos: licencia, ID del servidor y versión, nunca datos de tu tráfico o tus clientes.',
  [SELF_HOSTED_INSTALL]:
    'Ejecuta este comando como root en un servidor limpio. En unos diez minutos instala todo (Kubernetes, certificados HTTPS, la base de datos y el tracker). Ejecutarlo de nuevo actualiza la instalación y conserva los datos.',
  'Self-hosted': 'Servidor propio',
  'Enterprise': 'Enterprise',
  'Licence key': 'Clave de licencia',
  'Issue licence key': 'Emitir clave de licencia',
  'Rotate key': 'Renovar clave',
  'Rotate licence key?': '¿Renovar la clave de licencia?',
  'Licence key issued': 'Clave emitida',
  'Server deactivated': 'Servidor desactivado',
  'Deactivate this server?': '¿Desactivar este servidor?',
  'Servers': 'Servidores',
  'Production': 'Producción',
  'Revoked': 'Revocada',
  'Deactivated': 'Desactivado',
  'Deactivate': 'Desactivar',
  'Issued': 'Emitida',
  'Version': 'Versión',
  'See plans': 'Ver planes',
  'No servers activated yet.': 'Aún no hay servidores activados.',
  'Transfers left (30 days)': 'Traslados restantes (30 días)',
  'Could not load this page.': 'No se pudo cargar esta página.',
  'Licensing is temporarily unavailable. Try again later.': 'Las licencias no están disponibles temporalmente. Inténtalo más tarde.',
};

const pt = {
  [SELF_HOSTED_INTRO]:
    'Rode o tracker no seu próprio servidor ou numa nuvem dedicada. Sua chave de licença ativa um servidor de produção e um de teste.',
  [SELF_HOSTED_UPSELL]:
    'A instalação em servidor próprio vem com o plano Enterprise. Servidores ativados antes param quando a licença atual expira.',
  [SELF_HOSTED_KEY_ONCE]:
    'Esta é a única vez que a chave é exibida. Guarde-a em local seguro: você vai precisar dela ao instalar o tracker.',
  [SELF_HOSTED_ROTATE]:
    'A nova chave substitui a atual imediatamente. Servidores que ainda usam a chave antiga não conseguem renovar a licença e param em até {days} dias, a menos que você insira a nova chave neles.',
  [SELF_HOSTED_DEACTIVATE]:
    'O servidor perde a vaga imediatamente e para em até {days} dias. Use isso ao mover o tracker para outro servidor.',
  [SELF_HOSTED_RULES]:
    'Cada servidor se comunica conosco uma vez por dia e recebe uma licença válida por {days} dias. Se não conseguir, ou se a assinatura terminar, continua funcionando até essa licença expirar e então para. Um servidor de teste é limitado a {clicks} cliques por dia. Só dados técnicos são enviados: licença, ID do servidor e versão, nunca dados do seu tráfego ou dos seus clientes.',
  [SELF_HOSTED_INSTALL]:
    'Execute este comando como root num servidor limpo. Em cerca de dez minutos ele instala tudo (Kubernetes, certificados HTTPS, o banco de dados e o tracker). Executá-lo de novo atualiza a instalação e mantém os dados.',
  'Self-hosted': 'Servidor próprio',
  'Enterprise': 'Enterprise',
  'Licence key': 'Chave de licença',
  'Issue licence key': 'Emitir chave de licença',
  'Rotate key': 'Renovar chave',
  'Rotate licence key?': 'Renovar a chave de licença?',
  'Licence key issued': 'Chave emitida',
  'Server deactivated': 'Servidor desativado',
  'Deactivate this server?': 'Desativar este servidor?',
  'Servers': 'Servidores',
  'Production': 'Produção',
  'Revoked': 'Revogada',
  'Deactivated': 'Desativado',
  'Deactivate': 'Desativar',
  'Issued': 'Emitida',
  'Version': 'Versão',
  'See plans': 'Ver planos',
  'No servers activated yet.': 'Ainda não há servidores ativados.',
  'Transfers left (30 days)': 'Transferências restantes (30 dias)',
  'Could not load this page.': 'Não foi possível carregar esta página.',
  'Licensing is temporarily unavailable. Try again later.': 'O licenciamento está temporariamente indisponível. Tente novamente mais tarde.',
};

// Install card (SelfHostedInstall) and the server spec on Billing.
const INSTALL_EXTRA = {
  ru: {
    [SELF_HOSTED_SPEC_SHORT]:
      'Ваш сервер: 4 ядра CPU, 8 ГБ RAM, SSD 50 ГБ, Ubuntu или Debian (x86-64). Трекер устанавливается одной командой.',
    [SELF_HOSTED_KEY_HINT]:
      'Вместо X вставьте свой лицензионный ключ: он показывается один раз, при выпуске или перевыпуске.',
    [SELF_HOSTED_EMAIL_HINT]:
      'Первый аккаунт, зарегистрированный с этой почтой, получает права администратора сервера.',
    [SELF_HOSTED_DOMAIN_HINT]:
      'Без --domain трекер запустится на адресе вида 1-2-3-4.sslip.io. Для своего домена сначала направьте tracker.example.com и api.tracker.example.com на сервер, затем добавьте --domain tracker.example.com.',
    'Install on your server': 'Установка на свой сервер',
    'Server requirements': 'Требования к серверу',
    'Production server': 'Рабочий сервер',
    'Test server': 'Тестовый сервер',
    'Operating system': 'Система',
    'Disk space': 'Диск',
    'Connection': 'Сеть',
    'Ubuntu 22.04 / 24.04 or Debian 12, x86-64': 'Ubuntu 22.04 / 24.04 или Debian 12, x86-64',
    '4 cores (2 at least)': '4 ядра (минимум 2)',
    '8 GB (4 GB at least)': '8 ГБ (минимум 4 ГБ)',
    '50 GB SSD (30 GB free at least)': 'SSD 50 ГБ (минимум 30 ГБ свободно)',
    'Public IP address, ports 80 and 443 open': 'Публичный IP-адрес, открыты порты 80 и 443',
    'After the install': 'После установки',
    'Server state and licence': 'Состояние сервера и лицензии',
    'Upgrade to the newest signed release': 'Обновление до последней подписанной версии',
    'Back up the database to /var/backups/xpnsr': 'Резервная копия базы в /var/backups/xpnsr',
    'Copy command': 'Скопировать команду',
  },
  es: {
    [SELF_HOSTED_SPEC_SHORT]:
      'Tu servidor: 4 núcleos de CPU, 8 GB de RAM, SSD de 50 GB, Ubuntu o Debian (x86-64). El tracker se instala con un solo comando.',
    [SELF_HOSTED_KEY_HINT]:
      'Pon tu clave de licencia en lugar de las X: se muestra una sola vez, al emitirla o renovarla.',
    [SELF_HOSTED_EMAIL_HINT]:
      'La primera cuenta registrada con este correo obtiene derechos de administrador en el servidor.',
    [SELF_HOSTED_DOMAIN_HINT]:
      'Sin --domain el tracker arranca en una dirección como 1-2-3-4.sslip.io. Para tu propio dominio, primero apunta tracker.example.com y api.tracker.example.com al servidor y luego añade --domain tracker.example.com.',
    'Install on your server': 'Instalación en tu servidor',
    'Server requirements': 'Requisitos del servidor',
    'Production server': 'Servidor de producción',
    'Test server': 'Servidor de prueba',
    'Operating system': 'Sistema operativo',
    'Disk space': 'Disco',
    'Connection': 'Red',
    'Ubuntu 22.04 / 24.04 or Debian 12, x86-64': 'Ubuntu 22.04 / 24.04 o Debian 12, x86-64',
    '4 cores (2 at least)': '4 núcleos (mínimo 2)',
    '8 GB (4 GB at least)': '8 GB (mínimo 4 GB)',
    '50 GB SSD (30 GB free at least)': 'SSD de 50 GB (mínimo 30 GB libres)',
    'Public IP address, ports 80 and 443 open': 'IP pública, puertos 80 y 443 abiertos',
    'After the install': 'Después de la instalación',
    'Server state and licence': 'Estado del servidor y de la licencia',
    'Upgrade to the newest signed release': 'Actualizar a la última versión firmada',
    'Back up the database to /var/backups/xpnsr': 'Copia de seguridad de la base en /var/backups/xpnsr',
    'Copy command': 'Copiar comando',
  },
  pt: {
    [SELF_HOSTED_SPEC_SHORT]:
      'Seu servidor: 4 núcleos de CPU, 8 GB de RAM, SSD de 50 GB, Ubuntu ou Debian (x86-64). O tracker é instalado com um único comando.',
    [SELF_HOSTED_KEY_HINT]:
      'Coloque sua chave de licença no lugar dos X: ela é exibida uma única vez, ao ser emitida ou renovada.',
    [SELF_HOSTED_EMAIL_HINT]:
      'A primeira conta cadastrada com este e-mail recebe direitos de administrador no servidor.',
    [SELF_HOSTED_DOMAIN_HINT]:
      'Sem --domain o tracker inicia num endereço como 1-2-3-4.sslip.io. Para o seu próprio domínio, primeiro aponte tracker.example.com e api.tracker.example.com para o servidor e depois adicione --domain tracker.example.com.',
    'Install on your server': 'Instalação no seu servidor',
    'Server requirements': 'Requisitos do servidor',
    'Production server': 'Servidor de produção',
    'Test server': 'Servidor de teste',
    'Operating system': 'Sistema operacional',
    'Disk space': 'Disco',
    'Connection': 'Rede',
    'Ubuntu 22.04 / 24.04 or Debian 12, x86-64': 'Ubuntu 22.04 / 24.04 ou Debian 12, x86-64',
    '4 cores (2 at least)': '4 núcleos (mínimo 2)',
    '8 GB (4 GB at least)': '8 GB (mínimo 4 GB)',
    '50 GB SSD (30 GB free at least)': 'SSD de 50 GB (mínimo 30 GB livres)',
    'Public IP address, ports 80 and 443 open': 'IP público, portas 80 e 443 abertas',
    'After the install': 'Depois da instalação',
    'Server state and licence': 'Estado do servidor e da licença',
    'Upgrade to the newest signed release': 'Atualizar para a versão assinada mais recente',
    'Back up the database to /var/backups/xpnsr': 'Backup do banco em /var/backups/xpnsr',
    'Copy command': 'Copiar comando',
  },
};

export {
  SELF_HOSTED_INTRO,
  SELF_HOSTED_UPSELL,
  SELF_HOSTED_KEY_ONCE,
  SELF_HOSTED_ROTATE,
  SELF_HOSTED_DEACTIVATE,
  SELF_HOSTED_RULES,
  SELF_HOSTED_INSTALL,
  SELF_HOSTED_SPEC_SHORT,
  SELF_HOSTED_KEY_HINT,
  SELF_HOSTED_EMAIL_HINT,
  SELF_HOSTED_DOMAIN_HINT,
};
const SELF_HOSTED = {
  ru: { ...ru, ...INSTALL_EXTRA.ru },
  es: { ...es, ...INSTALL_EXTRA.es },
  pt: { ...pt, ...INSTALL_EXTRA.pt },
};
export default SELF_HOSTED;
